/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PaymentScheme from './payment-scheme';
import PaymentSchemeDetail from './payment-scheme-detail';
import PaymentSchemeUpdate from './payment-scheme-update';
import PaymentSchemeDeleteDialog from './payment-scheme-delete-dialog';

const PaymentSchemeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PaymentScheme />} />
    <Route path="new" element={<PaymentSchemeUpdate />} />
    <Route path=":id">
      <Route index element={<PaymentSchemeDetail />} />
      <Route path="edit" element={<PaymentSchemeUpdate />} />
      <Route path="delete" element={<PaymentSchemeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PaymentSchemeRoutes;
